// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progress[data-v-4bdf6b96] {\r\n  background-color: #f1f3f2;\n}\n.progress-bar[data-v-4bdf6b96] {\r\n  height: 8px;\n}\n.text-nowrap[data-v-4bdf6b96] {\r\n  white-space: nowrap;\n}\r\n", ""]);
// Exports
module.exports = exports;
